import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function P() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const [source, setSource] = useState('');
    const [gap, setGap] = useState(24);
    const LOCAL_SITES: string[] = ['de', 'za', 'fr', 'it', 'es', 'eu', 'uk', 'au'];
    const cards: any = [
        {
            img: '/responsive/picture/vanlife-roadtrips/15_1',
            text: t('secP_list1'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/YUYklvdjnis?si=oaQEG1FLJCdIonu8',
                    de: 'https://www.youtube.com/embed/BljtM9_XTs4?si=qip5mfIvNfVaQwbg',
                    za: 'https://www.youtube.com/embed/xLcCU29riWE?si=za-NI7Ghpi12c87Z',
                    fr: 'https://www.youtube.com/embed/jvtgKyf0peY?si=0PGuiNljObyzV5sT',
                    uk: 'https://www.youtube.com/embed/YUYklvdjnis?si=cPO6Lb8atNEo4f9w',
                    eu: 'https://www.youtube.com/embed/a2npZ_toi7U?si=xGDwvG2R0WO_ged6',
                    it: 'https://www.youtube.com/embed/R_dvRU7S-9g?si=iONPtsuEvEztNir-',
                    es: 'https://www.youtube.com/embed/JKo_Gqg-PPA?si=nSmASd0qPdUEizQc',
                    au: 'https://www.youtube.com/embed/3uO9fLnurB8?si=VwxOkrGNLAoDpsIs',
                    kr: 'https://www.youtube.com/embed/YUYklvdjnis?si=oaQEG1FLJCdIonu8',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/15_2',
            text: t('secP_list2'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=LAhDmbIF9XVledOO',
                    de: 'https://www.youtube.com/embed/r4VF3jWhdss?si=2lqTEkl-TxDMxABM',
                    za: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=C8VPQT-30jqwfYZk',
                    fr: 'https://www.youtube.com/embed/f-OCUmzlJ2M?si=cl-zwcaIbcTs_G80',
                    uk: 'https://www.youtube.com/embed/lnBFlLk0jiA?si=DSb5ZfBw0zIQd46Z',
                    eu: 'https://www.youtube.com/embed/Zlaw1AwPGIo?si=lfwr8gspNpquxoXE',
                    it: 'https://www.youtube.com/embed/AYCXJWGLx4k?si=ZFv07lpGKV3C0JTy',
                    es: 'https://www.youtube.com/embed/EtX5nt4vMMI?si=evxynfnT-2Nhrm9b',
                    au: 'https://www.youtube.com/embed/EYAPKD1_ye0?si=HljDwFVKCeLK848l',
                    kr: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=LAhDmbIF9XVledOO',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/15_3',
            text: t('secP_list3'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/3TEoBjHcCi0?si=OyoeXmhPZd3sLZiT',
                    de: 'https://www.youtube.com/embed/XtN6-CLbzt8?si=rld25Okx-R5_40-x',
                    za: 'https://www.youtube.com/embed/ULol9L_07_E?si=qi0WrQYGkVytYIKX',
                    fr: 'https://www.youtube.com/embed/NwA31h4QAvM?si=RxXm_MwT_ZmAhIaT',
                    uk: 'https://www.youtube.com/embed/cLUIyKrd9ts?si=t2jxORIwTSwjto0n',
                    eu: 'https://www.youtube.com/embed/Au6hRX3eiik?si=1plM9b-nx37d9sSx',
                    au: 'https://www.youtube.com/embed/MxSV3RdvwsU?si=M8g5Sx6whvibKwFd',
                    kr: 'https://www.youtube.com/embed/3TEoBjHcCi0?si=OyoeXmhPZd3sLZiT',
                };
                return map[locale] || map.us;
            })(),
        },
        {
            img: '/responsive/picture/vanlife-roadtrips/15_4',
            text: t('secP_list4'),
            video: (() => {
                const map: any = {
                    us: 'https://www.youtube.com/embed/Au6hRX3eiik?si=1fduvHMlUslHedt6',
                    de: 'https://www.youtube.com/embed/1SpIn7D11nI?si=VNxyMOfH3bJKn3l1',
                    za: 'https://www.youtube.com/embed/a2npZ_toi7U?si=ox5od9JlDnPJwiaK',
                    fr: 'https://www.youtube.com/embed/PzczrIeflPs?si=7xIuWKtJlNZJizlK',
                    uk: 'https://www.youtube.com/embed/WHSVYt-_hPM?si=GQyq3dX_gAcIYzB5',
                    au: 'https://www.youtube.com/embed/KHSKg0hRjxU?si=LsEShSkOSELZAex8',
                    kr: 'https://www.youtube.com/embed/Au6hRX3eiik?si=1fduvHMlUslHedt6',
                };
                return map[locale] || map.us;
            })(),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="vanlife-roadtrips-P" className={`vanlife-roadtrips-P ${css['vanlife-roadtrips-P']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secP_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar]}
                    spaceBetween={gap}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {(['us', 'ca', 'kr'].includes(locale)
                        ? [cards[0], cards[1], cards[3]]
                        : ['eu'].includes(locale)
                        ? cards.slice(0, 3)
                        : ['it', 'es'].includes(locale)
                        ? cards?.slice(0, 2)
                        : cards
                    )?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k} onClick={() => setSource(card?.video)}>
                            <EFPicture src={`${card?.img}${LOCAL_SITES.includes(locale) ? `_${locale}` : ''}.jpg`} alt={card?.text} />
                            <YoutubePlay className="youtube-icon" />
                            <div className="card-text-box">
                                <p className="card-text">{card?.text}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            {Object.keys(source)?.length > 0 && (
                <EFVideoModal visible={Boolean(source)} source={source} onClose={() => setSource('')} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
            )}
        </div>
    );
}
